import React from 'react';

import { Skeleton, Typography } from '@mui/material';

import { NumberFormatter } from '@waypoint/react/formatters';

type Props = {
  currentPage?: number;
  limit?: number;
  count?: number;
};
export default function PaginationCount({ currentPage, limit, count }: Props) {
  if (count === undefined || limit === undefined || currentPage === undefined) {
    return <Skeleton width={64} />;
  }

  if (count === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ mr: 1, lineHeight: 1 }}>
        No results
      </Typography>
    );
  }

  const startIndex = (currentPage - 1) * limit + 1;
  const endIndex = Math.min((currentPage - 1) * limit + limit, count);

  return (
    <Typography variant="body2" color="text.secondary" sx={{ mr: 1, lineHeight: 1 }}>
      <NumberFormatter value={startIndex} />
      {' - '}
      <NumberFormatter value={endIndex} />
      {' of '}
      <NumberFormatter value={count} />
    </Typography>
  );
}
